
import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
  getCurrentInstance,
  computed,
} from 'vue';
import { useCurrentCodeBlock } from '@/heplers/composables';
import { observeCodeExample, unobserveCodeExample } from '@/heplers/codeExampleObserver';
import {
  ANCHOR_CLASS,
  CODE_LINK_CLASS,
  CURRENT_CODE_LINK_CLASS,
} from '@/constants/element-classes';
import { convertToHtmlHelper } from '@/heplers';
import GlobalBus from '@/plugins/GlobalBus';
import { GlobalBusNames } from '@/templates/DataNames';

export default defineComponent({
  props: {
    uniqueId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const router = proxy?.$router;
    const anchor = ref<HTMLElement | null>(null);
    const { setCurrentCodeId, currentCodeExampleId } = useCurrentCodeBlock();

    const isCurrentCodeExample = computed(() => props.uniqueId === currentCodeExampleId.value);

    const updateObserveElement = () => {
      if (anchor.value) {
        unobserveCodeExample(anchor.value);
        observeCodeExample(anchor.value);
      }
    };

    const onClickAnchor = (id: string) => {
      setCurrentCodeId(id);
      router.push({ hash: id });
    };

    onMounted(async () => {
      GlobalBus.on(GlobalBusNames.CREATE_CODE_EXAMPLES_OBSERVER, updateObserveElement);
    });

    watch(
      () => [props.uniqueId, anchor.value],
      async () => {
        updateObserveElement();
      },
      { deep: true }
    );

    onBeforeUnmount(() => {
      if (anchor.value) unobserveCodeExample(anchor.value);
      GlobalBus.off(GlobalBusNames.CREATE_CODE_EXAMPLES_OBSERVER);
    });

    return {
      anchor,
      onClickAnchor,
      convertToHtmlHelper,
      isCurrentCodeExample,
      ANCHOR_CLASS,
      CODE_LINK_CLASS,
      CURRENT_CODE_LINK_CLASS,
    };
  },
});
